export default __webpack_public_path__ + "static/media/awaria-kiosk.8643956c.mp4";